export const ntpSettings = {
  ntp_primary: "pri_ntp",
};

export default ntpSettings;
